module.exports = __webpack_public_path__ + "static/media/world-map.a5e0a0e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/world-map.png
// module id = 176
// module chunks = 0